import classcat from 'classcat';
import * as React from 'react';

type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  /** The content to render within the button */
  children: React.ReactNode;

  /** The desired height and width of the button */
  size?: 'lg' | 'sm';

  /** The aesthetic to apply to the button */
  variant: 'primary' | 'secondary' | 'tertiary';
};

/**
 * Buttons are a type of **atom** that represent a `<button>` element.
 */
const Button: React.FC<ButtonProps> = ({
  children,
  className,
  size,
  variant,
  ...rest
}) => {
  const classes = classcat([
    `btn-${size}`,
    {
      'btn-outline-primary': variant === 'secondary',
      'btn-primary': variant === 'primary',
      'btn-link': variant === 'tertiary',
    },
    className,
  ]);

  return (
    <button {...rest} className={classes}>
      {children}
    </button>
  );
};

Button.defaultProps = {
  size: 'sm',
};

export default Button;
